export default __webpack_public_path__ + "static/polygon-d2402a13f1d162f5a2b766111be7e412.svg";